// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Takz","label":"styles_label__19pG-"};